import { render } from "./DriverDetailsPage.vue?vue&type=template&id=75670ec1&scoped=true"
import script from "./DriverDetailsPage.vue?vue&type=script&lang=js"
export * from "./DriverDetailsPage.vue?vue&type=script&lang=js"

import "./DriverDetailsPage.vue?vue&type=style&index=0&id=75670ec1&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75670ec1"]])

export default __exports__